<div style="height: 100%" id="div_67016dc8">
  <div class="title-container" id="div_title-container_2231aaad">
    <div
      class="title-container-centered"
      id="div_title-container-centered_0122caef"
    >
      Fleet Finder
    </div>
  </div>

  <p-steps
    [model]="this.steps"
    [(activeIndex)]="this.currentIndex"
    [readonly]="false"
    *ngIf="this.displaySteps"
    id="p-steps_802eeef2"
  ></p-steps>

  <router-outlet></router-outlet>
</div>
